import React from 'react';

function ucFirst(str = '') {
  return str.charAt(0).toUpperCase() + str.substring(1);
}

function getStatusLabel(status = 'Unknown') {
  return status === 'readyToShip' ? 'Ready to Ship' : ucFirst(status);
}

function getStatusClassNames(status = 'archived') {
  return status === 'archived' ? 'badge badge-secondary' : 'badge badge-info';
}

export default props => (
  <span className={getStatusClassNames(props.status)}>
    {getStatusLabel(props.status)}
  </span>
);



// WEBPACK FOOTER //
// ./src/components/orders/OrderStatus.js